/**
 * OverviewPage Component
 *
 * Wrapper component for overview/list pages that provides consistent layout
 * using DetailPageLayout. This allows overview pages to share the same
 * structure as detail pages while maintaining semantic clarity.
 *
 * Usage:
 * <OverviewPage
 *   backButton={{ to: "/dashboard" }}
 *   icon={FaServer}
 *   title="Scraper Overview"
 *   subtitle="Monitor scraper health and infrastructure"
 * >
 *   <YourTabComponent />
 * </OverviewPage>
 */

import React from "react";
import PropTypes from "prop-types";
import { DetailPageLayout } from "../DetailPageLayout";

export const OverviewPage = (props) => {
  // Simply pass all props through to DetailPageLayout
  // This wrapper exists for semantic clarity and future flexibility
  return <DetailPageLayout {...props} />;
};

OverviewPage.propTypes = {
  // Navigation
  backButton: PropTypes.shape({
    to: PropTypes.string,
    onClick: PropTypes.func,
    label: PropTypes.string,
  }).isRequired,

  // Header
  icon: PropTypes.elementType,
  iconColor: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.node,
  badges: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      variant: PropTypes.string,
      icon: PropTypes.elementType,
      style: PropTypes.object,
    })
  ),

  // Metadata
  metadata: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    })
  ),

  // Actions
  toolbar: PropTypes.node,
  actions: PropTypes.node,

  // States
  loading: PropTypes.bool,
  error: PropTypes.string,
  empty: PropTypes.bool,
  emptyMessage: PropTypes.string,
  emptyIcon: PropTypes.elementType,

  // Content
  children: PropTypes.node,
  className: PropTypes.string,
};

export default OverviewPage;
